// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"75ce4267","455":"99dcc968","644":"016c353c"}[chunkId] + ".chunk.js";
};